import Modal from "react-modal";
import useAppAccessor from "../../hooks/useappAccessor";
import { getBrandColor } from "../../utils/brand.util";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    height: "40%",
    width: "30%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    border: 0,
    transform: "translate(-50%, -50%)",
    overflow: "hidden",
    borderRadius: 11,
    zindex: 99999,
  },
  overlay: {
    backgroundColor: "rgba(24, 24, 24,0.8)",
    zindex: 99999,
  },
};
const AlertRotateModal = (props: any) => {
  const { getUserData } = useAppAccessor();
  const { language, client } = getUserData();
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
  }

  function closeModal() {
    // setIsOpen(false);
    // props.handleCloseMediaInteraction()
  }

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);


  const lightenColor = (color: any, percent: any) => {
    let num = parseInt(color.replace("#", ""), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = ((num >> 8) & 0x00ff) + amt,
      B = (num & 0x0000ff) + amt;
    return (
      "#" +
      (
        0x1000000 +
        (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 1 ? 0 : B) : 255)
      )
        .toString(16)
        .slice(1)
    );
  };

  const lightenMainColor = (color: any, percent: any) => {
    const lightenedColor = lightenColor(color, percent);
    return lightenedColor;
  };

  const customStylesMobile = {
    content: {
      top: "40%",
      left: 0,
      right: 0,
      width: "100%",
      border: 0,
      bottom: 0,
      backgroundColor: '#404040'
      // backgroundImage: `linear-gradient(90deg, ${lightenMainColor(
      //   getBrandColor(client),
      //   30
      // )}, ${getBrandColor(client)} `,
    },
    overlay: {
      backgroundColor: "rgba(24, 24, 24,0.5)",
      zIndex: 99999,
    },
  };

  return (
    <Modal
      isOpen={props.modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={isMobile ? customStylesMobile : customStyles}
      contentLabel="Example Modal"
    >
      <div
        className=" flex w-full h-full  items-center justify-center  modalBGColor"
        style={{
          backgroundColor: '#404040'
        }}
      >
        <div className="flex flex-col justify-center items-center">
          <span className="text-xl text-white">Please rotate your phone for bettter user experience</span>

          <div className="flex mt-14">
          <button
              className="pl-9 pr-9 pt-2 pb-2 rounded text-white ml-1"
              onClick={() => {
                props.handleClickOnNo();
              }}
              style={{ backgroundColor: `${getBrandColor(client)}` }}
            >
             OK
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default AlertRotateModal;
